import { BeneficiaryEntityType, BeneficiaryTransferDestination } from 'types/beneficiaries'
import { WalletType } from 'types/types'
import { PayoutInstructionTypes, PayoutRequest } from 'types/unifiedPayouts/unifiedPayouts'
import {
  AmplitudeEvent,
  AmplitudeEventAction,
  AmplitudeEventCategory,
} from 'utils/amplitude/amplitudeEvents'
import track from 'utils/tracker'
import { WithdrawForm } from '../../Withdraw/Withdraw'

interface PayoutV1WalletLogDetails {
  currency: string
  id: number
  lsid: string
  name: string
  supportedTransferDestinations: BeneficiaryTransferDestination[]
}

interface PayoutV1BeneficiaryLogDetails {
  alias: string
  currency: string
  entityType?: BeneficiaryEntityType
  id?: number
  name: string
  reference: string
  transferDestination: BeneficiaryTransferDestination
}

export const getFirstPartyPayoutRequest = (
  formValues: WithdrawForm,
  selectedWallet: WalletType
): PayoutRequest => {
  return {
    walletId: selectedWallet?.lsid,
    amount: {
      value: formValues?.amount,
      currency: selectedWallet?.currency?.code,
    },
    paymentReference: formValues?.reference,
    instruction: {
      type: PayoutInstructionTypes?.FIAT,
      beneficiary: {
        reference: formValues?.bankAccountId,
        storeForFutureUse: false,
      },
    },
}}

export const logV1Payout = (
  wallet: PayoutV1WalletLogDetails,
  beneficiary: PayoutV1BeneficiaryLogDetails,
  isThirdParty = false
) => {
  const eventName = isThirdParty ? AmplitudeEvent.PAY_REQUEST : AmplitudeEvent.WITHDRAW_REQUEST
  track.Amp.track(eventName, {
    category: AmplitudeEventCategory.MERCHANT_PORTAL,
    action: AmplitudeEventAction.CLICK,
    version: 1,
    wallet,
    beneficiary,
  })
}
